import React from "react";
// import { Link } from "react-scroll"; // For scrolling
import { Link } from "react-router-dom"; // For routing

export const Navigation = ({  location, scrollToSections}) => {

  const logoImgStyles = {
    width: '6rem',  // Adjust width as needed
    height: '6rem', // Maintain aspect ratio
    
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link to="/" onClick={() => scrollToSections('header')}>
            <img
              src="img/mo2cloud-logo-cropped.svg"
              alt="Mo2Cloud Logo"
              style={logoImgStyles}
            />
          </Link>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li className={location.pathname === '/features' ? 'active' : ''}>
            <Link to="/features" 
                  className="page-scroll" 
                  onClick={(e) => {
                    scrollToSections('features'); // Scroll to the features section
                  }}>
              Features
            </Link>
            </li>
            <li className={location.pathname === '/about' ? 'active' : ''}>
            <Link to="/about" className="page-scroll" onClick={() => scrollToSections('about')} >
                About
              </Link>
            </li>
            <li className={location.pathname === '/services' ? 'active' : ''}>
            <Link to="/services" className="page-scroll" onClick={() => scrollToSections('services')} >
                Services
              </Link>
            </li>
            <li className={location.pathname === '/portfolio' ? 'active' : ''}>
            <Link to="/portfolio" className="page-scroll" onClick={() => scrollToSections('portfolio')} >
                Portfolio
              </Link>
            </li>
            {/* <li>
              <Link to="/testimonials" className="page-scroll">
                Testimonials
              </Link>
            </li>
            <li>
              <Link to="/team" className="page-scroll">
                Team
              </Link>
            </li> */}
            <li className={location.pathname === '/contact' ? 'active' : ''}>
            <Link to="/contact" className="page-scroll" onClick={() => scrollToSections('contact')}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
